import React from 'react';

const SvgHelpPreview: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46 46" {...props}>
      <defs>
        <clipPath id="helpPreview_svg__a">
          <path
            data-name="Ret\xE2ngulo 1697"
            transform="translate(-.121 -.121)"
            d="M0 0h46v46H0z"
          />
        </clipPath>
      </defs>
      <g
        data-name="Grupo 11088"
        transform="translate(.121 .121)"
        clipPath="url(#helpPreview_svg__a)"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path
          data-name="Caminho 24750"
          d="M38.131 38.131V11.014a3.389 3.389 0 00-3.39-3.388H11.016a3.389 3.389 0 00-3.39 3.388v20.337a3.39 3.39 0 003.39 3.39h20.761z"
        />
        <path
          data-name="Caminho 24751"
          d="M22.875 28.2a.332.332 0 10.334.332.328.328 0 00-.334-.332"
        />
        <path
          data-name="Caminho 24752"
          d="M22.879 23.019v-.458a3.432 3.432 0 011.853-2.933 3.374 3.374 0 001.817-2.877 3.674 3.674 0 00-7.348 0"
        />
      </g>
    </svg>
  );
};

export default SvgHelpPreview;
